/**
 * Status of the operation.
 */
export enum ContentOperationStatus {
    STARTING = 0,
    RUNNING = 1,
    SUCCESS = 2,
    ERROR = 3,
}

/**
 * Running operation on a content.
 * An operation is a lock, potentialy preventing other operations to run or content to be updated.
 */
export interface ContentOperation<
    Payload extends { [key: string]: string } = { [key: string]: string },
> {
    /**
     * Unique ID of the operation. It is used to enforce idempotency.
     */
    id: string;

    /**
     * Status of the operation.
     */
    status: ContentOperationStatus;

    /**
     * Payload of the operation.
     */
    payload: Payload;

    /**
     * Timestamp when the operation was created.
     */
    createdAt: number;

    /**
     * Timestamp when the operation was last updated.
     */
    updatedAt: number;

    /**
     * Incremental ID for the update of the operation.
     */
    updateId: number;

    /**
     * Progress of the operation.
     * Progress is cursor / target.
     */
    cursor: number;
    target: number;

    /**
     * Time to live of the operation, after last update, in seconds.
     */
    expireAfter: number;
}
